<template>     
    <div id="basic-info" class="card mt-4">
      <div class="card-header">
        <h5>{{ $t('settings.Breed_info') }}</h5>
      </div>
      <div class="card-body pt-0">
        <div class="row">
          <div class="col-6">
              <div class="input-group input-group-static null">
                  <label>{{ $t('settings.Type') }} *</label>
                  <select id="userManualTypeId" v-model="state.userManualTypeId" class="form-control form-control-default">
                      <option value="">{{ $t('settings.Select_referencetype') }}</option>
                      <option v-for="userManualType in state.userManualTypes" :key="userManualType.id" :value="userManualType.id">
                          {{ userManualType.name }}
                      </option>
                  </select>
                  <span v-if="v$.userManualTypeId.$error" class="text-sm text-danger">
                      {{ v$.userManualTypeId.$errors[0].$message }}
                  </span>
              </div>
          </div>
          <div class="col-6" v-if="['Admin'].includes(userRoleName)">
              <div class="input-group input-group-static null">
                  <label>{{ $t('settings.Association') }}</label>
                  <select id="associationId" v-model="state.associationId" class="form-control form-control-default">
                      <option value="">{{ $t('settings.Select_association') }}</option>
                      <option v-for="association in state.associations" :key="association.id" :value="association.id">
                          {{ association.abbreviation }}
                      </option>
                  </select>
                  <!--span v-if="v$.associationId.$error" class="text-sm text-danger">
                      {{ v$.associationId.$errors[0].$message }}
                  </span-->
              </div>
          </div>                                                
        </div>
        <div class="row mt-4">
            <div class="col-6">
                <div class="input-group input-group-static null">
                    <label>{{ $t('settings.Title') }} *</label>
                    <input v-model="state.title" type="text" class="form-control form-control-default" :placeholder="$t('settings.Title')">
                    <span v-if="v$.title.$error" class="text-sm text-danger">
                        {{ v$.title.$errors[0].$message }}
                    </span>
                </div>
            </div>
        </div>
        <div class="row mt-4">
            <div class="col-12">
                <div class="input-group input-group-static null">
                    <label>{{ $t('settings.Message') }} *</label>
                    <textarea class="form-control form-control-default" :rows="10"
                      v-model="state.message"
                      :placeholder="$t('settings.Message')">
                    </textarea>
                    <span v-if="v$.message.$error" class="text-sm text-danger">
                        {{ v$.message.$errors[0].$message }}
                    </span>
                </div>
            </div>
        </div>
        <div class="row mt-4">
            <div class="col-6">
                <div class="input-group input-group-static null">
                    <label>{{ $t('settings.StartDate') }}</label>
                    <input v-model="state.startDate" type="date" :max="todayDate" class="form-control form-control-default" :placeholder="$t('settings.StartDate')">                                                        
                </div>
            </div>
            <div class="col-6">
                <div class="input-group input-group-static null">
                    <label>{{ $t('settings.ExpiryDate') }}</label>
                    <input v-model="state.expiryDate" type="date" class="form-control form-control-default" :placeholder="$t('settings.ExpiryDate')">                                                        
                </div>
            </div>
        </div>
        <div class="row mt-4">
            <div class="col-6">
                <div class="input-group input-group-static null">
                  <label>{{ $t('user.Role') }}</label>
                  <select id="roleName" v-model="state.roleName" class="form-control form-control-default">
                      <option value="">{{ $t('user.Select_role') }}</option>
                      <option v-for="role in state.roles" :key="role.id" :value="role.name">
                          {{ role.name }}
                      </option>
                  </select>
                </div>
            </div>
            <div class="col-6">
                <div class="input-group input-group-static null">
                    <label class="d-block mb-1" style="width: inherit;">{{ $t('settings.Active') }}</label>
                    <div class="d-block mt-1">
                        <material-switch v-model="state.isActive" id="isActive" name="isActive" />
                    </div>
                </div>
            </div>
        </div>
        <div class="row mt-4">
          <div class="col-12">
            <input type="hidden" v-model="state.id" class="form-control">
            <router-link to="/settings" class="btn btn-sm bg-gradient-danger float-start">{{ $t('common.Cancel') }}</router-link>
            <button v-on:click="updateBreed" class="btn btn-sm bg-gradient-success mr-2 float-end">{{ $t('common.Update') }}</button>
          </div>
        </div>
      </div>
      
    </div>       
  </template>
  
  <script>
  import * as Choices from "choices.js";
  import MaterialSwitch from "@/components/MaterialSwitch.vue";
  import axios from 'axios'
  import useValidate from '@vuelidate/core'
  import { required, helpers, } from '@vuelidate/validators'
  import { reactive, computed } from 'vue'
  import { useI18n } from 'vue-i18n'
  import { useStore } from 'vuex'
  
  export default {
    name: "UserManualDetail",
    setup() {
        const { t } = useI18n()
        const store = useStore()
        const todayDate = new Date().toISOString().split('T')[0];
        const translatedRole = (name) => {
            return t(`roles.${name.toLowerCase()}`)
        }

        const state = reactive ({            
            userManual: [],            
            id: '',
            userManualTypeId: '',
            associationId: '',
            title: '',
            message: '',
            roleName: '',
            startDate: null,
            expiryDate: null,
            isActive: false,
            associations:[],
            userManualTypes:[],
            roles:[]
        })

        const userRoleName = computed(() => store.state.user?.roleName)
        
        const rules = computed(() => {
            //const isAdmin = userRoleName.value === 'Admin';

            return {
                title: { required: helpers.withMessage(t('common.Required'), required) },
                message: { required: helpers.withMessage(t('common.Required'), required) },
                userManualTypeId: {
                    required: helpers.withMessage(t('common.Required'), required),
                    isSelected: helpers.withMessage(t('common.Select_an_usermanual_type'), value => value !== '')
                },
                //associationId: isAdmin
                //? {
                //    required: helpers.withMessage(t('common.Required'), required),
                //    isSelected: helpers.withMessage(t('common.Select_an_association'), value => value !== '')
                //}
                //: {}
            }
        })
        
        const v$ = useValidate(rules, state)

        return {
            state,
            v$,
            translatedRole,
            userRoleName,
            choicesInstanceAssociation: null,
            choicesInstanceUserManualType: null,
            choicesInstanceRole: null,
            todayDate
        }
    },    
    components: {
      MaterialSwitch      
    },
    data() {
      return {        
        gets: [],
        error: '',        
      };
    },
    async mounted() {  
      this.id = this.$route.params.id;
      try {
        await this.fetchUserManualData(this.id);
      } catch (e) {        
        console.error('mounted: fetchUserManualData error', e);
      }
    },
    methods: { 
      async fetchUserManualData(userManualId) {
        try {
            this.$store.commit('setShowLoading', true);

            const response = await axios.get(`UserManual/${userManualId}`);
            this.gets = response.data;

            if (this.gets.success) {
                this.state.userManual = this.gets.data;                
                this.state.id = this.state.userManual.manualId;
                this.state.userManualTypeId = this.state.userManual.userManualTypeId;
                this.state.associationId = this.state.userManual.associationId;
                this.state.title = this.state.userManual.title;
                this.state.message = this.state.userManual.message;
                this.state.roleName = this.state.userManual.roleName;
                this.state.startDate = this.state.userManual.startDate;
                this.state.expiryDate = this.state.userManual.expiryDate;
                this.state.isActive = this.state.userManual.isActive;

                await Promise.all([                
                  this.fetchAndPopulate({
                    url: "UserManualType/getall/",
                    listPath: "data",
                    stateKey: "userManualTypes",
                    selectId: "userManualTypeId",
                    instanceKey: "choicesInstanceUserManualType",
                    selectedValueGetter: () => this.state.userManualTypeId
                  }),

                  this.fetchAndPopulate({
                    url: this.userRoleName === 'Admin' ? "auth/getroles" : "auth/getassociationadminroles",
                    listPath: "data.roleList",
                    targetContainer: "formData",
                    stateKey: "roles",
                    formKey: "roles",
                    selectId: "roleName",
                    instanceKey: "choicesInstanceRole",
                    selectedValueGetter: () => this.state.roleName
                  })
                ]);
              
                if (this.userRoleName === 'Admin') {
                  await this.fetchAndPopulate({
                    url: "Association/getall",
                    listPath: "data.associationList",
                    stateKey: "associations",
                    selectId: "associationId",
                    instanceKey: "choicesInstanceAssociation",
                    selectedValueGetter: () => this.state.associationId
                  });
                }
            } else {
                this.$showError('errors.Contact_system_admin');
            }
        } catch (e) {
            const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
            this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
        }
        
        this.$store.commit('setShowLoading', false);
      },

      async fetchAndPopulate({
          url,
          listPath = "data",
          targetContainer = "state",
          stateKey,
          formKey,
          selectId,
          instanceKey,
          selectedValueGetter = () => null
      }) {
          try {
              const response = await axios.get(url);
              const result = response.data;
              
              const arr = listPath.split('.').reduce((acc, p) => (acc && acc[p] !== undefined) ? acc[p] : null, result);

              if (!result.success || !Array.isArray(arr)) {
                  this.$showError(this.$t('errors.Error_fetching_data') || 'Error fetching data');
                  return;
              }

              if (targetContainer === "formData" && formKey) {
                  this.state[formKey] = arr;
              }

              if (stateKey) {
                  this.state[stateKey] = arr;
              }
              
              if (selectId && instanceKey) {
                  this.$nextTick(() => {
                      this.initializeChoicesDropdown({
                          id: selectId,
                          dataList: this.state[stateKey] || arr,
                          selectedValue: typeof selectedValueGetter === 'function' ? selectedValueGetter() : selectedValueGetter,
                          instanceKey
                      });
                  });
              }
          } catch (e) {
              const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
              this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
          }
      },
      
      initializeChoicesDropdown({ id, dataList = [], selectedValue, instanceKey }) {
          const element = document.getElementById(id);
          if (!element || element.tagName !== "SELECT") {
            console.error(`Choices: Invalid or missing select element with ID "${id}".`);
            return;
          }

          if (this[instanceKey] && typeof this[instanceKey].destroy === 'function') {
              try { 
                  this[instanceKey].destroy(); 
              } catch (err) { 
                  console.warn('Choices destroy failed', err); 
              }
          }

          this[instanceKey] = new Choices(element, {
              searchEnabled: true,
              itemSelectText: '',
              shouldSort: false,
              placeholder: true,
          });
          
          const preferName = String(id) === 'roleName';
          const keyOrder = preferName
            ? ['name', 'Name', 'id', 'Id', 'ID', 'value', 'Value']
            : ['id', 'Id', 'ID', 'value', 'Value', 'name', 'Name'];

          const valueFromItem = (item) => {
            if (item == null) return null;
            // primitives (string/number/boolean)
            if (typeof item !== 'object') return item;
            for (const k of keyOrder) {
                if (Object.prototype.hasOwnProperty.call(item, k) && item[k] !== undefined && item[k] !== null) {
                    return item[k];
                }
            }
            // lastly, if item has a single enumerable property, return its value
            const keys = Object.keys(item);
            if (keys.length === 1) return item[keys[0]];
            return null;
        };

        const valueExists = (value) => {
          if (value === null || value === undefined || value === '') return false;
          return dataList.some(item => {
              const v = valueFromItem(item);
              if (v === null || v === undefined) return false;
              return String(v) === String(value);
          });
        };

        if (selectedValue !== null && selectedValue !== undefined && selectedValue !== '') {
            const exists = valueExists(selectedValue);
            if (exists) {
                try {
                    this[instanceKey].setChoiceByValue([String(selectedValue)]);
                } catch (err) {
                    // fallback if Choices fails — set native select value and dispatch change
                    element.value = selectedValue;
                    element.dispatchEvent(new Event('change', { bubbles: true }));
                }
            } else {
                try {
                    // clear selection if selectedValue not found
                    if (typeof this[instanceKey].clearStore === 'function') {
                        this[instanceKey].clearStore();
                    } else {
                        element.value = '';
                        element.dispatchEvent(new Event('change', { bubbles: true }));
                    }
                } catch (err) { /* ignore */ }
            }
        }
      },
  
      async fetchAllUsermanualTypeData() {
          return this.fetchAndPopulate({
              url: "UserManualType/getall/",
              listPath: "data",
              stateKey: "userManualTypes",
              selectId: "userManualTypeId",
              instanceKey: "choicesInstanceUserManualType",
              selectedValueGetter: () => this.state.userManualTypeId
          });
      },

      async fetchAllRoleData() {
          return this.fetchAndPopulate({
              url: this.userRoleName === 'Admin' ? "auth/getroles" : "auth/getassociationadminroles",
              listPath: "data.roleList",
              targetContainer: "formData",
              stateKey: "roles",
              formKey: "roles",
              selectId: "roleName",
              instanceKey: "choicesInstanceRole",
              selectedValueGetter: () => this.state.roleName
          });
      },

      async fetchAllAssociationData() {
          return this.fetchAndPopulate({
              url: "Association/getall",
              listPath: "data.associationList",
              stateKey: "associations",
              selectId: "associationId",
              instanceKey: "choicesInstanceAssociation",
              selectedValueGetter: () => this.state.associationId
          });
      },
      async updateBreed() {   
            try {
                this.$store.commit('setShowLoading', true);

                this.v$.$validate();
                console.log(this.state.id);

                if(!this.v$.$error) {

                    const formData = {
                      id: this.state.id,
                      userManualTypeId: this.state.userManualTypeId,
                      associationId: this.userRoleName === 'Admin'
                          ? this.state.associationId
                          : this.$store.state.associationAdminAssociationId,
                      title: this.state.title,
                      message: this.state.message,
                      roleName: this.state.roleName,
                      startDate: this.state.startDate,
                      expiryDate: this.state.expiryDate,
                      isActive: this.state.isActive
                    };
                    const response = await axios.put('UserManual/update', formData);
                    this.gets = response.data;

                    if (this.gets.success) {
                      this.$showSuccess('errors.Success_user_manual_updated_successfully');
                      this.$router.push('/settings');
                    } else {
                        this.$showError('errors.Contact_system_admin');
                    }
                }                
            } catch (e) {
                const errorMessage = e.response?.data?.message || e.message || this.$t('errors.Something_went_wrong');
                this.$showError(`${this.$t('errors.Contact_system_admin')}: ${errorMessage}`);
            }                        
            this.$store.commit('setShowLoading', false);
      },
    }
  };
</script>  
<style>
.choices {
  margin-bottom: 0px !important;
}
</style>